import api from "../axiosInstance";

const BASE_URL = process.env.REACT_APP_API_URL + "/api/v1/email-log";

// Get all email logs
export const getAllEmailLogsAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.templateId) queryParams.append("templateId", params.templateId);
    if (params.scheduleId) queryParams.append("scheduleId", params.scheduleId);
    if (params.status) queryParams.append("status", params.status);
    if (params.recipientEmail) queryParams.append("recipientEmail", params.recipientEmail);
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);

    const response = await api.get(`${BASE_URL}?${queryParams.toString()}`);
    return response.data;
  } catch (e) {
    console.log("Error getting email logs: " + e.message);
    throw e;
  }
};

// Get email logs by template ID
export const getLogsByTemplateAPI = async (templateId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.status) queryParams.append("status", params.status);

    const response = await api.get(
      `${BASE_URL}/template/${templateId}?${queryParams.toString()}`
    );
    return response.data;
  } catch (e) {
    console.log("Error getting logs by template: " + e.message);
    throw e;
  }
};

// Get email logs by schedule ID
export const getLogsByScheduleAPI = async (scheduleId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.status) queryParams.append("status", params.status);

    const response = await api.get(
      `${BASE_URL}/schedule/${scheduleId}?${queryParams.toString()}`
    );
    return response.data;
  } catch (e) {
    console.log("Error getting logs by schedule: " + e.message);
    throw e;
  }
};

// Get email log statistics
export const getLogStatsAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.templateId) queryParams.append("templateId", params.templateId);
    if (params.scheduleId) queryParams.append("scheduleId", params.scheduleId);
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);

    const response = await api.get(`${BASE_URL}/stats?${queryParams.toString()}`);
    return response.data;
  } catch (e) {
    console.log("Error getting log stats: " + e.message);
    throw e;
  }
};

// Get single email log by ID
export const getEmailLogByIdAPI = async (id) => {
  try {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  } catch (e) {
    console.log("Error getting email log: " + e.message);
    throw e;
  }
};
